import Choices from 'choices.js';

const selector = '[data-autocomplete]';
const autocompleteSelects = document.querySelectorAll(selector);

const classNames = {
    containerOuter: 'choices',
    containerInner: 'choices-inner',
    input: 'choices-input',
    inputCloned: 'choices-input--cloned',
    list: 'choices-list',
    listItems: 'choices-list--multiple',
    listSingle: 'choices-list--single',
    listDropdown: 'choices-list--dropdown',
    item: 'choices-item',
    itemSelectable: 'choices-item--selectable',
    itemDisabled: 'choices-item--disabled',
    itemChoice: 'choices-item--choice',
    placeholder: 'choices-placeholder',
    group: 'choices-group',
    groupHeading: 'choices-heading',
    button: 'choices-button',
    activeState: 'is-active',
    focusState: 'is-focused',
    openState: 'is-open',
    disabledState: 'is-disabled',
    highlightedState: 'is-highlighted',
    hiddenState: 'is-hidden',
    flippedState: 'is-flipped',
    loadingState: 'is-loading',
    noResults: 'has-no-results',
    noChoices: 'has-no-choices'
};

const createLabelId = (index) => {
    let labelId = `autocomplete-label-${index}`;
    let count = 1;

    while (document.getElementById(labelId)) {
        labelId = `autocomplete-label-${index}-${count}`;
        count += 1;
    }

    return labelId;
};

const getAssociatedLabel = (element) => {
    const labels = element.labels
        ? Array.from(element.labels)
        : Array.from(document.querySelectorAll('label')).filter(label => label.htmlFor === element.id);

    return labels.find(label => label.textContent.trim()) || null;
};

const getAccessibleName = (element, index) => {
    const label = getAssociatedLabel(element);

    if (label) {
        if (!label.id) {
            label.id = createLabelId(index);
        }

        return {
            labelId: label.id,
            labelText: label.textContent.trim()
        };
    }

    const labelId = element.getAttribute('aria-labelledby');

    if (labelId) {
        return {
            labelId,
            labelText: ''
        };
    }

    return {
        labelId: '',
        labelText: element.getAttribute('aria-label') || ''
    };
};

const setAccessibleName = (element, labelId, labelText) => {
    if (labelId) {
        element.setAttribute('aria-labelledby', labelId);
        element.removeAttribute('aria-label');
        return;
    }

    if (labelText) {
        element.setAttribute('aria-label', labelText);
    }
};

if (autocompleteSelects.length) {
    autocompleteSelects.forEach((autocompleteSelect, index) => {
        const { labelId, labelText } = getAccessibleName(autocompleteSelect, index);

        new Choices(autocompleteSelect,
            {
                classNames,
                noResultsText: 'Ingen resultater',
                noChoicesText: 'Ingen tilgjengelige valg',
                itemSelectText: 'Klikk for å velge',
                addItemText: (value) => {
                    return `Press Enter for å legge til <b>"${value}"</b>`;
                },
                maxItemText: (maxItemCount) => {
                    return `Kun ${maxItemCount} verdier kan legges til.`;
                },
                callbackOnInit() {
                    setAccessibleName(this.containerOuter.element, labelId, labelText);
                    setAccessibleName(this.input.element, labelId, labelText);
                }
            });
    });
}
